import React from "react";
import FeaturesRepo from "../repository/FeaturesRepo";
import FeatureList from "../data-list/FeatureList";

const Features = () => {
  return (
    <div
      className="feature-area feature-bg-image pb--50 horizontal-feature"
      id="features"
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title text-center mb--40">
              <h2>
                AWESOME <span className="theme-color">FEATURES</span>
              </h2>
              <p>
                NIBEBE IS EVERYWHERE;
                <span className="text-success fw-bolder fs-3"> </span>share
                rides anywhere you are--whether you are a driver or
                passenger--and Nibebe will take you there
              </p>
            </div>
          </div>
        </div>
        <div className="row mt--30">
          <div className="col-lg-7 offset-lg-5">
            <div className="feature-list">
              {FeaturesRepo.featuresData.map((feature, index) => (
                <FeatureList key={index} feature={feature} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features;
